export const SOCIAL_PROVIDERS = [
  'facebook',
  'instagram',
  'linkedin',
] as const

export type SocialProvider = (typeof SOCIAL_PROVIDERS)[number]
